/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const IsNullUri: core.serialization.ObjectSchema<serializers.IsNullUri.Raw, Truvity.IsNullUri> =
    core.serialization.object({});

export declare namespace IsNullUri {
    export interface Raw {}
}
